<template>
    <div class="">
        <div class="search-widget--wrapper">
            <div class="search-widget" :class="{
            'active':searchRowExpand
            }"
            >
                <button @click="searchActivated()" class="search-widget--button">
                    <i class=" d-inline-block fa fa-search" aria-hidden="true"></i>
                </button>
                <!--set text color here-->
                <input v-if="searchRowExpand"
                        ref="searchInput"
                        class="search-widget--input border-0 d-inline-block ml-3 mb-0 mt-0"
                        v-model="searchString" type="text"
                        placeholder="Search" aria-label="Search"
                >
                <button v-if="searchRowExpand" @click="searchRowExpand = false" class="search-widget--close">
                    <i class="fa fa-close"></i>
                </button>
            </div>
            <transition name="accordionShowDown">
                <div v-if="!searchRowExpand && filteredCompiledList.length > pagination.limit" class="watch-transition search-widget--aux">
                    <paginate
                            :page_id="pagination.topId"
                            :page_start="pagination.start"
                            :page_end="pagination.end"
                            :page_limit="pagination.limit"
                            :pages_length="records.length"
                            :select_options="selectRowsPerPageList"
                            :callback_name="pagination.callback_name"
                            pageinate_class=""
                            @pageinate_event="paginatePage"
                    ></paginate>
                </div>
            </transition>
        </div>
        <!--list of data-->
        <div class="table-responsive">
            <div class="d-table table">
                <transition-group name="slideLeft" tag="div" class="tbody">
                    <div class="d-table-row cursor-pointer"
                            v-on:click="readRow(list)"
                            v-for="list,index in filteredCompiledList.slice(pagination.start, pagination.end = setPaginationEnd())"
                            :key="index"
                    >
                        <div v-if="list.date">{{list.date}}</div>
                        <div class="d-table-cell ">
                            <span v-if="list.first_name">{{list.first_name}}</span>
                            <span v-else class="text-muted">Not set</span>
                        </div>
                        <div class="d-table-cell ">
                            <span v-if="list.last_name">{{list.last_name}}</span>
                            <span v-else class="text-muted">Not set</span>
                        </div>
                        <div class="d-table-cell "> {{list.email}}</div>
                        <div class="d-table-cell strong">
                            <div>
                                £{{list.total}}
                            </div>
                        </div>
                    </div>

                </transition-group>

            </div>

        </div>

        <!--footer-->
        <div class="d-flex justify-content-end align-items-center p-2"
                v-if="filteredCompiledList.length > pagination.limit"
        >

            <paginate
                    :page_id="pagination.bottomId"
                    :page_start="pagination.start"
                    :page_end="pagination.end"
                    :page_limit="pagination.limit"
                    :pages_length="records.length"
                    :select_options="selectRowsPerPageList"
                    :callback_name="pagination.callback_name"
                    pageinate_class=""
                    @pageinate_event="paginatePage"
            ></paginate>

        </div>
    </div>
</template>

<script>

	import {uniqueId} from "../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds";
	import {format as formatMoney} from "../../../../../app/Shared/Resources/Assets/js/helpers/money";
	import {route as laravel_route} from '../../../../../app/Shared/Resources/Assets/js/helpers/routes';

	Vue.component('paginate', require('../../../../../app/Shared/Resources/Assets/js/components/Pagination.vue'));

	//ADD JSDOC HERE!!!!!
	export default {
		name: 'sales-list',
		props: {
			records: Array,
			laravel_route_uri: String,
			sale_route_name: String
		},
		created() {
		},
		destroyed() {
		},
		mounted() {
			this.pagination.end = this.pagination.limit;
			// this.readDev();

		},
		watch: {
			records(item) {

			}
		},
		data() {
			return {
				searchInput: '',
				searchRowExpand: false,
				selectRowsPerPageList: [10, 50, 100],
				searchString: "",
				// records: [],
				elementFilterList: ['first_name', 'last_name'],
				pagination: {
					topId: uniqueId('rows-per-page'),
					bottomId: uniqueId('rows-per-page'),
					callback_name: 'pageinate_event',
					numberOfPages: 0,
					limit: 10,
					start: 0,
					end: 50
				}
			}
		},
		methods: {
			readRow(list) {
				let params = {
					route: this.sale_route_name,
					params: {
						sale: list.id
					}
				};

				return laravel_route(this.laravel_route_uri, params, function (response) {

					window.location.assign(response);
					// window.location.href = response;
					return response;
				});

			},
			setPaginationEnd() {
				return (this.pagination.start + this.pagination.limit > this.records.length ? this.records.length : this.pagination.start + this.pagination.limit);
			},
			money(total) {
				return formatMoney(total);
			},
			log(x) {
				console.log('x', x);
			},
			searchActivated() {
				this.searchRowExpand = true;
				this.$nextTick(() => this.$refs.searchInput.focus())
				// this.$refs.searchInput.$el.focus();
			},
			paginatePage(data) {
				/**
				 * set the number of rows to be sown in the list
				 */
				if (data.action == 'rows') {
					this.pagination.limit = data.value;
				}
				/**
				 * calculate the starting index of the paginated result
				 */
				if (data.action == 'next') {
					let origStart = this.pagination.start;
					if (data.value == true) {
						this.pagination.start = this.pagination.start + this.pagination.limit;
					}
					else {
						this.pagination.start = this.pagination.start - this.pagination.limit;
					}

					if (this.pagination.start >= this.records.length) {
						// get the remaining left overs
						console.log(origStart, 'next limited', this.pagination.start);

						this.pagination.start = origStart;
						console.log('result', this.pagination.start);
					}
					if (this.pagination.start < 0) {
						this.pagination.start = 0;
						console.log('prev limited');

					}
				}
			},
			hasMatchInSearch(item, searchString) {
				console.log('hasMatchInSearch', item, searchString);

				if (typeof item !== 'undefined' && item !== null) {

					return item.toLowerCase().indexOf(searchString) !== -1;
				}
				return false;

			}
		},
		computed: {
			filteredCompiledList() {
				let compiledList_array = this.records,
					searchString = this.searchString,
					_this = this;

				// console.log('compiledList_array',compiledList_array);
				if (!searchString) {
					return compiledList_array;
				}

				searchString = searchString.trim().toLowerCase();
				// console.log('compiledList_array', compiledList_array);
				try {
					compiledList_array = compiledList_array.filter(function (item) {
						if (_this.hasMatchInSearch(item.first_name, searchString) ||
							_this.hasMatchInSearch(item.last_name, searchString) ||
							_this.hasMatchInSearch(item.email, searchString) ||
							_this.hasMatchInSearch(item.date, searchString)
						) {
							return item;
						}
					});
				}
				catch (e) {
					console.error('e', e);
				}
				this.$nextTick(function () {
					this.$emit('sales_list_loaded', 'sales-list');
				});
				// Return an array with the filtered data.
				return compiledList_array;
			}
		}
	}
</script>
<style>
    .thead {
        display: table-header-group;
    }

    .tbody {
        display: table-row-group;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/lists/SalesList.vue?74d3991b